import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class HeaderUtil {

    getHeader() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('token'),
                'tienda': localStorage.getItem('tienda')
            })
        };
    }

    getHeaderMultipart() {
        return {
            headers: new HttpHeaders({
                // 'Content-Type': 'multipart/form-data',
                // 'enctype': 'multipart/form-data',
                'Authorization': localStorage.getItem('token'),
                'tienda': localStorage.getItem('tienda')
            })
        };
    }

    getHeaderSimple() {
        return {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
}
